"use client"

import MaintenancePage from "pages/MaintenancePage/MaintenancePage"
import { useEffect } from "react"

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Locale-specific error caught:", error)
  }, [error])

  // You can add a button to try resetting the error state if desired
  // <button onClick={() => reset()}>Try again</button>
  return <MaintenancePage />
}
